import BaseComponent from 'scripts/BaseComponent.js';
import { timeUntil } from '@tobynatooor/countdown';

export default class CountdownTimer extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      data: '.js-timer-data',
      years: '.js-timer-years',
      days: '.js-timer-days',
      hours: '.js-timer-hours',
      minutes: '.js-timer-minutes',
      seconds: '.js-timer-seconds',
      promoTitle: '.js-promoTitle',
      countdownFallback: '.js-countdownFallback',
    };

    this.dom = {
      $component: component,
      $data: this.$get(this.refs.data),
      $days: this.$get(this.refs.days),
      $hours: this.$get(this.refs.hours),
      $minutes: this.$get(this.refs.minutes),
      $seconds: this.$get(this.refs.seconds),
      $promoTitle: document.querySelector(this.refs.promoTitle),
      $countdownFallback: document.querySelector(this.refs.countdownFallback),
    };

    this.state = {
      timer: null,
      timezoneOffset: '',
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    const { dom, state } = this;
    const timerData = JSON.parse(dom.$data.innerHTML);
    const timezoneOffset = this.getESTOffset();
    const startTime = `${timerData.dateTime}.${timezoneOffset}`; // sets timezone to EST
    state.timer = timeUntil(startTime);
    state.timezoneOffset = timezoneOffset;
    this.updateVisibility(state.timer);

    setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  updateTimer() {
    const { dom, state } = this;
    const timerData = JSON.parse(dom.$data.innerHTML);
    const startTime = `${timerData.dateTime}.${state.timezoneOffset}`; // sets timezone to EST

    state.timer = timeUntil(startTime);
    this.updateVisibility(state.timer);

    if (!state.timer.expired) {
      dom.$days.innerText = (`${state.timer.days % 365}`).padStart(2, '0');
      dom.$hours.innerText = (`${state.timer.hours % 24}`).padStart(2, '0');
      dom.$minutes.innerText = (`${state.timer.minutes % 60}`).padStart(2, '0');
      dom.$seconds.innerText = (`${state.timer.seconds % 60}`).padStart(2, '0');
    }
  }

  updateVisibility(timer) {
    const { dom } = this;

    if (timer.expired) {
      dom.$component.classList.add('hide');
      dom.$promoTitle.classList.add('hide');
      dom.$countdownFallback.classList.remove('hide');
    } else {
      dom.$component.classList.remove('hide');
      dom.$promoTitle.classList.remove('hide');
      dom.$countdownFallback.classList.add('hide');
    }
  }

  getESTOffset() {
    const today = new Date();
    const stdTimezoneOffset = () => {
      const jan = new Date(0, 1);
      const jul = new Date(6, 1);
      return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    };

    if (today.getTimezoneOffset() < stdTimezoneOffset()) {
      return '000-04:00';
    }
    return '000-05:00';
  }
}
